import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { injectIntl } from "react-intl";
import confirmDelete from '../ConfirmDelete';
import ImgToolTip from '../ImgTooltip';

const SessionRow = ({ id, name, description, deleteFn, intl }) => {
  const delText = intl.formatMessage({ id: 'confirm.s.session-delete' })

  return (
    <div className="added-event-container">
      <div className="e-name-container">
        <div className="e-name">
          <div className="event-icon-container">
            <img
              className="event-icon rounded-circle"
              src={`https://ui-avatars.com/api/?name=${name}&size=85&color=ff7142`}
              alt=""
            />
          </div>
          <div className="m-l-45">
            <h6>
              {name}
            </h6>
            <span>{description}</span>
          </div>
        </div>
        <div className="del-event-container justify-content-center">
          <Button
            onClick={() => {
              confirmDelete(intl, id, undefined, ('session', _id => (
                deleteFn('session', _id)
              )), delText);
            }}
          >
            <ImgToolTip className="icon-normal" intl={intl} placement="left" tooltiptext={`action.delete-session`} id="tooltip-download-latest" img={`/icons/delete.png`} />
            <ImgToolTip className="icon-hover" intl={intl} placement="left" tooltiptext={`action.delete-session`} id="tooltip-download-latest-hover" img={`/icons/delete-hover.png`} />
            <ImgToolTip className="icon-focus" intl={intl} placement="left" tooltiptext={`action.delete-session`} id="tooltip-download-latest-focus" img={`/icons/delete-focus.png`} />
          </Button>
        </div>
      </div>
      <Link className="d-flex w-10" to={`/session/edit/${id}`}>
        <Button className="btn-return">{intl.formatMessage({ id: 'button.s.session-update' })}</Button>
      </Link>
    </div>
  );
};

export default injectIntl(SessionRow);
